import { transform, map, domScheduler } from "@studiometa/js-toolkit/utils";
import { AbstractSliderChild } from "./AbstractSliderChild.js";
class SliderProgress extends AbstractSliderChild {
  /**
   * Config.
   */
  static config = {
    name: "SliderProgress",
    refs: ["progress"]
  };
  /**
   * Update the progress indicator.
   */
  update(index) {
    domScheduler.read(() => {
      const { progress } = this.$refs;
      const x = map(index, 0, this.$parent.indexMax, progress.clientWidth * -1, 0);
      domScheduler.write(() => {
        transform(progress, { x });
      });
    });
  }
}
export {
  SliderProgress
};
//# sourceMappingURL=SliderProgress.js.map
